var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{attrs:{"url":"/api/v1/coupon","attributes":[
    {
      attribute: 'id',
      name: 'ID'
    },
    {
      attribute: 'slug',
      name: 'Code'
    },
    {
      attribute: 'start',
      name: 'Start',
      type: 'DateTimeCell'
    },
    {
      attribute: 'end',
      name: 'Ende',
      type: 'DateTimeCell'
    },
    {
      attribute: 'amount',
      name: 'Menge an Coins'
    },
    {
      attribute: 'active',
      name: 'Aktiv?',
      type: 'CheckMarkerCell'
    },
    {
      attribute: 'for_one',
      name: 'Einmal einlösbar?',
      type: 'CheckMarkerCell'
    },
    {
      attribute: 'redeem_count',
      name: 'Einlösungen',
      type: 'ModalCell',
      modal: 'RedeemedCouponCustomersModal',
      sortable: false
    },
    {
      type: 'CouponActionCell',
      name: 'Aktionen'
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }